/* eslint-disable jsx-a11y/anchor-has-content */
import Link from "next/link"
import type { LinkProps } from "next/link"
import { AnchorHTMLAttributes } from "react"

/** Default styles beat global SCSS `a { color: black }` for MDX / CustomLink usage */
const linkStyles =
	"break-words text-primary-500 underline underline-offset-[0.15em] hover:text-primary-600 dark:text-primary-400 dark:hover:text-primary-300"

const CustomLink = ({
	href,
	className,
	...rest
}: LinkProps & AnchorHTMLAttributes<HTMLAnchorElement>) => {
	const merged = [linkStyles, className].filter(Boolean).join(" ")
	const isInternalLink = href && href.startsWith("/")
	const isAnchorLink = href && href.startsWith("#")

	if (isInternalLink) {
		return <Link className={merged} href={href} {...rest} />
	}

	if (isAnchorLink) {
		return <a className={merged} href={href} {...rest} />
	}

	return <a className={merged} target="_blank" rel="noopener noreferrer" href={href} {...rest} />
}

export default CustomLink
